import {SinotticoStato} from './SinotticoStato';

/**
 * I parametri della **richiesta** — 1:1 con `SinotticoFiltroRequest` del backend: `orgId` e le due
 * finestre, e **nient'altro**.
 *
 * ⚠️ Il parametro si chiama `orgId`, **non** `organizzazioneId`. Sbagliare il nome non produce
 * alcun errore: il valore arriva a `0`, la query non restituisce nulla, e la pagina appare
 * semplicemente vuota — indistinguibile da un'organizzazione senza risorse.
 */
export interface SinotticoRichiesta {
  orgId: number;
  /** Finestra scorrevole della produzione oraria (min), e ampiezza della lettura degli eventi. */
  finestraMinuti: number;
  /** Finestra degli ordini terminati (min). */
  finestraTerminatiMinuti: number;
}

// ⚠️ C'era una terza finestra, `finestraEventiMinuti`, che selezionava l'operatore fra gli eventi
// recenti della risorsa. È stata rimossa: l'operatore è ora una proprietà dell'ORDINE mostrato e
// non scade.
export const FINESTRE_PREDEFINITE: Omit<SinotticoRichiesta, 'orgId'> = {
  finestraMinuti: 60,
  finestraTerminatiMinuti: 480,
};

export type SinotticoOrdinamento = 'codice' | 'stato' | 'produzione' | 'fermo';

/**
 * I criteri di **filtro**, che vivono interamente sul client (FR-025) e nella query string della
 * pagina (FR-029). **Non** sono parametri dell'endpoint: se lo fossero, ogni cambio di filtro
 * richiederebbe una rifetch (SC-003) e un pre-filtro per stato azzererebbe i contatori delle pill
 * (FR-027).
 */
export interface SinotticoFiltro {
  reparti: string[];
  tipoRisorsa: number;
  stati: SinotticoStato[];
  operatore: string;
  linea: string;
  ricerca: string;
  soloAnomalie: boolean;
  soloConOrdini: boolean;
  ordinamento: SinotticoOrdinamento;
  ordinamentoAsc: boolean;
  vista: 'grid' | 'table';
  /**
   * Mostra i tempi nelle tessere. Spegnendoli la tessera si accorcia e ne entrano di più a schermo,
   * che su un monitor a parete di un reparto grande è la differenza fra vedere tutte le macchine e
   * doverne scorrere metà.
   *
   * ⚠️ Sta qui, e non fra lo stato locale della pagina, per la stessa ragione di `vista`: è una
   * preferenza che deve **sopravvivere al ricaricamento** — un monitor sempre acceso si riavvia, e
   * nessuno torna a rimetterla a mano. Non è un filtro e **non** riduce l'insieme mostrato.
   */
  mostraTempi: boolean;
}

export const FILTRO_VUOTO: SinotticoFiltro = {
  reparti: [],
  tipoRisorsa: 0,
  stati: [],
  operatore: '',
  linea: '',
  ricerca: '',
  soloAnomalie: false,
  soloConOrdini: false,
  ordinamento: 'codice',
  ordinamentoAsc: true,
  vista: 'grid',
  mostraTempi: true,
};
